import React from 'react';
import BaseComponent from 'apps/new-web/views/component';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import MuiDialog from '@material-ui/core/Dialog';
import ProfileLinks from './profile-links';
import I18n from 'apps/new-web/views/components/i18n';

const styles = {
  root: {
    top: '56px',
    height: 'calc(100% - 56px)'
  },
  paper: { boxShadow: 'none' },
};

export default class MobileDialog extends BaseComponent {
  static get propTypes() {
    return {
      classes: PropTypes.shape({
        root: PropTypes.string,
        paper: PropTypes.string,
        backdrop: PropTypes.string
      })
    };
  }

  constructor(props) {
    super(props);

    this.state = { dialogOpen: false };
  }

  handleDialogToggle() {
    this.setState(prevState => ({ dialogOpen: !prevState.dialogOpen }));
  }

  componentDidMount() {
    const currentUrl = window.location.href;
    const isTestOrDevPage = currentUrl.includes('ifit-test') || currentUrl.includes('ifit-dev');
    this.setState({ isTestOrDevPage });
  }

  render() {
    const { isTestOrDevPage } = this.state;

    return (
      <div className="mobile-dialog-container">
        <button
          className={ classnames('mobile-dialog-link', { 'dialog-open': this.state.dialogOpen }) }
          onClick={ this.handleDialogToggle }
          aria-label={ I18n.translate('Open main menu') }
        >
          <span className="mobile-dialog-line mobile-dialog-top" />
          <span className="mobile-dialog-line mobile-dialog-middle" />
          <span className="mobile-dialog-line mobile-dialog-bottom" />
        </button>
        <MuiDialog
          className="mobile-dialog hide-on-desktop"
          fullScreen={ true }
          open={ this.state.dialogOpen }
          scroll="paper"
          style={ styles.root }
          PaperProps={{
            style: styles.paper
          }}
        >
          <nav
            className="mobile-dialog-nav"
            aria-label={ I18n.translate('Main navigation') }
            aria-expanded={ this.state.dialogOpen }
          >
            { isTestOrDevPage
              ? <a className="mobile-nav-link" href="https://iconfitness--sbx.sandbox.my.site.com/MC/login" target="_blank">Support Sandbox</a>
              : <a className="mobile-nav-link" href="https://my.ifit.com/MC/login" target="_blank"><I18n>Support</I18n></a>
            }
            <a className="mobile-nav-link shop" href="https://shop.ifit.com/" target="_blank"><I18n desc="iFIT store">Shop</I18n></a>
            <a className="mobile-nav-link renewal" href="https://www.ifit.com/renewal/">- <I18n desc="iFIT store">Membership</I18n></a>
            <a className="mobile-nav-link" href="https://blog.ifit.com" target="_blank"><I18n>Blog</I18n></a>
            <a className="mobile-nav-link sr-only skip" href="#" onClick={ this.handleDialogToggle }><I18n desc="Click to close the navigation menu.">Close menu</I18n></a>
          </nav>
          <ProfileLinks fullname={ this.props.user.fullname } />
        </MuiDialog>
      </div>
    );
  }
}
